import { OrderEffects } from './order.effects';
export const effects: any[] = [OrderEffects];
